import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { useTranslation } from "react-i18next";
import { bannerImg } from "../../assets/index";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const HeroCell = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.1 });

  const [text] = useTypewriter({
    words: isInView
      ? [t("banner.words1"), t("banner.words2"), t("banner.words3")]
      : [""],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  return (
    <motion.div
      ref={ref}
      variants={item}
      className="bento-cell p-6 flex flex-col items-center justify-center gap-4 overflow-hidden relative
                 lgl:col-start-1 lgl:col-end-6 lgl:row-start-1 lgl:row-end-4
                 md:col-span-2"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-designColor/10 via-transparent to-purple-500/5 rounded-2xl" />

      <motion.div
        animate={{ y: [-5, 5, -5] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        className="relative z-10"
      >
        <img
          src={bannerImg}
          alt="Axel Chevenement"
          className="w-[200px] h-auto lgl:w-[280px] drop-shadow-[0_0_40px_rgba(0,127,255,0.25)]"
        />
      </motion.div>

      <div className="relative z-10 text-center">
        <h1 className="text-2xl lgl:text-3xl font-bold text-white font-titleFont">
          Axel Chevenement
        </h1>
        <p className="text-sm lgl:text-base text-gray-400 mt-1">
          {t("banner.expertise")}{" "}
          <span className="text-designColor">
            {isInView ? text : ""}
            {isInView && (
              <Cursor cursorBlinking="false" cursorStyle="|" cursorColor="#007FFF" />
            )}
          </span>
        </p>
      </div>
    </motion.div>
  );
};

export default HeroCell;
